export default __webpack_public_path__ + "static/media/fakiehhos.b1224839.webp";